import { useQuery } from "@tanstack/react-query";
import { api } from "../lib/api";
import type { BrandReadiness } from "../../../shared/types.ts";

export function useBrandReadiness(brandId: string | null | undefined) {
  return useQuery({
    queryKey: ["brand-readiness", brandId],
    queryFn: () => api.get<{ data: BrandReadiness }>(`/api/brands/${encodeURIComponent(brandId!)}/readiness`),
    enabled: !!brandId,
  });
}
